import { PlayCircle } from "lucide-react";
import { mediaThumb, isVideoFile } from "@/lib/media";

/* A preview thumbnail for any LMS video link:
   - YouTube / Vimeo -> static provider thumbnail image
   - direct video file (.mp4/.webm/…) -> first frame via a muted <video> poster
   - anything else -> a play-icon placeholder so every video still shows a preview */
export function MediaThumb({ url, className = "", onClick, testId }) {
  const img = mediaThumb(url);
  const base = `object-cover rounded border border-border bg-black ${className}${onClick ? " cursor-pointer" : ""}`;
  if (img) {
    return <img src={img} alt="" className={base} onClick={onClick} data-testid={testId} loading="lazy" onError={(e) => { e.currentTarget.style.visibility = "hidden"; }} />;
  }
  if (isVideoFile(url)) {
    return <video src={`${url}#t=0.5`} muted playsInline preload="metadata" className={base} onClick={onClick} data-testid={testId} />;
  }
  return (
    <div className={`${base} flex items-center justify-center`} onClick={onClick} data-testid={testId}>
      <PlayCircle className="h-5 w-5 text-white/80" />
    </div>
  );
}
